<template>
  <div v-if="isOpen" class="modal-overlay">
    <div class="modal-content">
      <p>{{ message }}</p>
      <div>
        <button @click="handleCancel">{{ $t('cancel') }}</button>
        <button @click="handleConfirm">{{ $t('delete') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useConfirm } from '@/composables/useConfirm';

const {
  isOpen,
  message,
  handleCancel,
  handleConfirm,
} = useConfirm();
</script>